export const onViewportEnter = () => {
  const className = 'hidden'
  const observer = new IntersectionObserver( entries => {
    entries.forEach( entry => {
      const el = entry.target

      if( entry.isIntersecting ) {
        el.classList.remove( className )
      } else {
        el.classList.add( className )
      }
    } );
  } );

  const elms = document.getElementsByClassName( className )
  for( let i = 0; i < elms.length; i++ ) {
    const el = elms[ i ]
    observer.observe( el )
  }

  return () => {
    if( elms ) {
      for( let i = 0; i < elms.length; i++ ) {
        const el = elms[ i ]
        observer.unobserve( el )
      }
    }
  }
}

